import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { useParams } from "react-router-dom";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 992,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 576,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

const OurCollection = () => {
  const { id } = useParams(); // ✅ get category id from URL
  const [collectionData, setCollectionData] = useState([]);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        console.log("✅ Category Id from URL:", id);

        if (!id) {
          console.warn("⚠️ No ID found in URL.");
          return;
        }

        const endpoint = `https://dharajwebbackend.concentics.com/api/Product_collection/${id}`;
        console.log("📡 Fetching data from:", endpoint);

        const response = await axios.get(endpoint);
        console.log("🟢 Full API Response:", response.data);

        if (response.data && response.data.status && Array.isArray(response.data.products)) {
          setCollectionData(response.data.products);
          console.log("✅ Collection Data:", response.data.products);
        } else {
          console.warn("⚠️ Unexpected API response format:", response.data);
        }
      } catch (error) {
        console.error("❌ Error fetching collection:", error);
      }
    };

    fetchCollection();
  }, [id]);

  return (
    <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <h2 className="section-title text-center mb-5">Our Collection</h2>
        <Row>
          {collectionData.length > 0 ? (
            <Slider {...settings}>
              {collectionData.map((item, index) => (
                <Col key={index} className="mb-4 mb-lg-0">
                  <div
                    className="text-center rounded bg-white mx-2 p-3 shadow-sm"
                    style={{ transition: "transform 0.3s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <a
                      href={`/productdetails/${item.id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        src={`https://dharajwebbackend.concentics.com/productimage/${item.productImage}`}
                        alt={item.productName || "Product"}
                        className="img-fluid rounded"
                        style={{
                          height: 200,
                          width: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) =>
                          (e.currentTarget.src =
                            "https://via.placeholder.com/300x300?text=No+Image")
                        }
                      />
                      <h6 className="mt-3 text-dark fw-semibold">
                        {item.productName || "Unnamed Product"}
                      </h6>
                      <p className="text-muted mb-0">
                        {item.price ? `₹${item.price}` : "Price Not Available"}
                      </p>
                    </a>
                  </div>
                </Col>
              ))}
            </Slider>
          ) : (
            <p className="text-center">No products found for this category.</p>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default OurCollection;
